import { SearchBar } from '@practium/ui';
import type { StateReferenceDTO } from '../../types/parameters.types';
import { RegionThumbnailCard } from '../Cards/RegionThumbnailCard/RegionThumbnailCard';
import styles from './SelectBaseLeftPanel.module.css';

interface SelectBaseLeftPanelProps {
	references: StateReferenceDTO[];
	searchQuery: string;
	onSearchChange: (query: string) => void;
	onSelectBase: (reference: StateReferenceDTO) => void;
}

export const SelectBaseLeftPanel = ({ references, searchQuery, onSearchChange, onSelectBase }: SelectBaseLeftPanelProps) => {
	const query = searchQuery.toLowerCase();

	return (
		<div className={styles.panel}>
			<SearchBar value={searchQuery} onChange={onSearchChange} />
			<div className={styles.grid}>
				{references
					.filter((reference) => reference.referenceCode.toLowerCase().includes(query))
					.map((reference) => (
						<RegionThumbnailCard
							key={reference._id}
							name={reference.referenceCode}
							stateCodes={reference.stateCode}
							onClick={() => onSelectBase(reference)}
						/>
					))}
			</div>
		</div>
	);
};
